// src/components/dashboard/DashboardHero.js
//
// The top card on the student AND educator dashboards — one design for both,
// so they look like the same product:
//
//   ┌──────────────────────────────────────────────────────────┐
//   │ [SBL logo]                         [Educator] [Plan] [VA] │
//   │           (avatar)  Good morning,                         │
//   │                     Ms. Rivera!                           │
//   │                     a sentence that says what to do next  │
//   │                     [chip] [chip]                         │
//   │    [ 🪙 340 ] [ 🛍 Shop ] [ 🏆 Leaders ] [ 🗺 Daily … ]    │
//   └──────────────────────────────────────────────────────────┘
//
// The page passes the words and the buttons; this only lays them out.
//
//   <DashboardHero
//      profile={userData} name="Maya" line="…" chips={[…]}
//      onEditAvatar={fn} editRef={ref} fallbackUrl="" actions={<>…</>} />

import React from "react";
import MyAvatar, { AvatarViewSwitch } from "../avatar/MyAvatar";
import AccountBadge from "../AccountBadge";
import "./dashboard.css";

const LOGO =
  "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2FSBLLogoBlackTM.png?alt=media&token=2f8fde38-b373-4367-9ade-a7b68bae3b6f";

export const timeGreeting = (d = new Date()) => {
  const h = d.getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
};

const DashboardHero = ({ profile, name, line, chips = [], onEditAvatar, editRef, actions, children, variant = "student" }) => (
  <section className={`sbl-hero is-${variant}`}>
    <div className="sbl-hero-top">
      <img src={LOGO} alt="Smart Board Learning" className="sbl-hero-logo" />
      <div className="sbl-hero-badges">
        <AccountBadge profile={profile} layout="row" />
      </div>
    </div>

    <div className="sbl-hero-main">
      <div className="sbl-hero-avatar-col">
        <div className="sbl-hero-avatar">
          <MyAvatar size={112} fullSize={220} toggle className="sbl-hero-av" title="My avatar" />
          <button ref={editRef} type="button" className="sbl-hero-edit" onClick={onEditAvatar} aria-label="Edit my avatar" title="Edit my avatar">
            ✎ <span>Edit</span>
          </button>
        </div>
        <AvatarViewSwitch />
      </div>
      <div className="sbl-hero-text">
        <p className="sbl-hero-hi">{timeGreeting()},</p>
        <h1 className="sbl-hero-name">{name}!</h1>
        {line && <p className="sbl-hero-line">{line}</p>}
        {chips.filter(Boolean).length > 0 && (
          <div className="sbl-hero-chips">
            {chips.filter(Boolean).map((c, i) => (
              <span key={i} className="sbl-hero-chip">
                {c}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>

    {actions && <div className="sbl-hero-actions">{actions}</div>}
    {children}
  </section>
);

export default DashboardHero;
